import axios from 'axios';
import { UseTraceContext } from '@b2bsoft/tracecontext';

import { UseLoaderInterceptor } from './interceptors/LoaderInterceptor';
import { UseErrorInterceptor } from './interceptors/ErrorInterceptor';
import { UseQaInterceptor } from './interceptors/QaModeInterceptor';
import { StoreModel } from '../models/Index';

const baseHttp = axios.create();
const apiHttp = axios.create({});
const logHttp = axios.create({});


export interface ApiOptions {
    host?: string;
    accessToken?: string | null;
    olrIdentity?: string | null;
    isQA?: boolean;
}

export function setupAPI(options: ApiOptions, Store: StoreModel) {
    apiHttp.defaults.baseURL = options.host || apiHttp.defaults.baseURL;
    logHttp.defaults.baseURL = options.host || logHttp.defaults.baseURL;

    if (options.isQA) {
        UseQaInterceptor(apiHttp);
    }

    UseTraceContext(apiHttp, Store.traceContext);
    UseTraceContext(logHttp, Store.traceContext);

    UseErrorInterceptor(apiHttp, Store);
    UseLoaderInterceptor(apiHttp, Store);

    updateAPI(options);
    return apiHttp;
}

export function updateAPI(options: ApiOptions) {
    if (options.accessToken) {
        apiHttp.defaults.headers.common['Authorization'] = `Bearer ${options.accessToken}`;
        logHttp.defaults.headers.common['Authorization'] = `Bearer ${options.accessToken}`;
    }

    if (options.olrIdentity) {
        apiHttp.defaults.headers.common['OlrIdentity'] = options.olrIdentity;
        logHttp.defaults.headers.common['OlrIdentity'] = options.olrIdentity;
    }

    return apiHttp;
}

export interface ResponseWrapper<T> {
    data: T | null;
    errors: ResponseError[];
}
export interface ResponseError {
    code?: string | null;
    message?: string;
    data: any;
}

export { apiHttp as http, baseHttp, logHttp };
